module.exports = __webpack_public_path__ + "static/img/9.041312a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/9.png
// module id = 79fl
// module chunks = 1